import * as z from "zod/v4";
import {
  postPurchaseConditionBlockSchema,
  postPurchaseConditionSchema,
  postPurchaseSegmentSchema,
} from "../advanced-flow/advanced-flow-db-parser";

const postPurchaseConditionInProgressSchema_ = z.union([
  postPurchaseConditionSchema,
  z.object({ segmentableCharacteristic: z.undefined() }),
]);
export const postPurchaseConditionInProgressSchema: z.ZodType<PostPurchaseConditionInProgress> =
  postPurchaseConditionInProgressSchema_;
export type PostPurchaseConditionInProgress = z.infer<
  typeof postPurchaseConditionInProgressSchema_
>;

const postPurchaseConditionBlockInProgressSchema_ =
  postPurchaseConditionBlockSchema
    .omit({ conditions: true })
    .extend({ conditions: z.array(postPurchaseConditionInProgressSchema) });
export const postPurchaseConditionBlockInProgressSchema: z.ZodType<PostPurchaseConditionBlockInProgress> =
  postPurchaseConditionBlockInProgressSchema_;
export interface PostPurchaseConditionBlockInProgress
  extends z.infer<typeof postPurchaseConditionBlockInProgressSchema_> {}

const postPurchaseSegmentInProgressSchema_ = postPurchaseSegmentSchema
  .omit({ conditionBlocks: true })
  .extend({
    conditionBlocks: z.array(postPurchaseConditionBlockInProgressSchema),
  });
export const postPurchaseSegmentInProgressSchema: z.ZodType<PostPurchaseSegmentInProgress> =
  postPurchaseSegmentInProgressSchema_;
export interface PostPurchaseSegmentInProgress
  extends z.infer<typeof postPurchaseSegmentInProgressSchema_> {}
